"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteSuperVenue = deleteSuperVenue;
exports.getSuperVenueList = getSuperVenueList;
exports.saveSuperVenue = saveSuperVenue;
var _request = _interopRequireDefault(require("@/utils/request"));
// 查询榜单会场活动列表
function getSuperVenueList(data) {
  return (0, _request.default)({
    url: '/portal/system/activity/super/venue/query',
    method: 'post',
    data: data
  });
}

// 保存榜单会场活动（新增/编辑）
function saveSuperVenue(data) {
  return (0, _request.default)({
    url: '/portal/system/activity/super/venue/save',
    method: 'post',
    data: data
  });
}

// 删除榜单会场活动
function deleteSuperVenue(data) {
  return (0, _request.default)({
    url: '/portal/system/activity/super/venue/delete',
    method: 'post',
    data: data
  });
}